import React, { useState } from 'react';
import './Contact.css';

const details = [
  {
    icon: '✦',
    label: 'Location',
    value: '14 Rue de la Paix, 75001 Paris, France',
  },
  {
    icon: '✦',
    label: 'Hours',
    value: 'Tue–Sat: 6:30 PM – 11:30 PM\nSun: 12:00 PM – 4:00 PM',
  },
  {
    icon: '✦',
    label: 'Reservations',
    value: '+33 1 42 86 00 00',
  },
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | sending | sent

  const handleChange = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');
    setTimeout(() => setStatus('sent'), 1600);
  };

  return (
    <section className="contact" id="contact">
      <div className="contact-top-rule" />

      <div className="section-inner">
        <div className="contact-layout">
          {/* Left: Info */}
          <div className="contact-info">
            <div className="gold-rule reveal">
              <span /><em>Get in Touch</em><span />
            </div>
            <h2 className="section-title reveal delay-1">
              Reserve your <em>evening</em>
            </h2>
            <p className="contact-body reveal delay-2">
              Tables at Aurum are released 30 days in advance. We seat 34 guests per service — and every one of them gets our full attention.
            </p>

            <div className="contact-details">
              {details.map((d, i) => (
                <div key={d.label} className={`contact-detail reveal delay-${i + 2}`}>
                  <span className="detail-icon">{d.icon}</span>
                  <div>
                    <span className="detail-label">{d.label}</span>
                    <span className="detail-value">{d.value}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="contact-socials reveal delay-5">
              {['Instagram', 'Facebook', 'TripAdvisor'].map((s) => (
                <a key={s} href="#!" className="social-link">{s}</a>
              ))}
            </div>
          </div>

          {/* Right: Form */}
          <div className="contact-form-wrap reveal-right delay-2">
            {status === 'sent' ? (
              <div className="contact-success">
                <span className="success-icon">✦</span>
                <h3>Merci, {form.name || 'dear guest'}.</h3>
                <p>Your reservation enquiry has been received. We will respond within one business day. We look forward to welcoming you.</p>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Isabelle Moreau"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="isabelle@example.com"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="message">Your Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    placeholder="I'd like to reserve a table for two on Saturday the 15th — preferably near the window. Please confirm availability."
                    rows={5}
                    required
                  />
                </div>
                <button
                  type="submit"
                  className={`btn-gold contact-submit ${status === 'sending' ? 'sending' : ''}`}
                  disabled={status === 'sending'}
                >
                  <span>{status === 'sending' ? 'Sending…' : 'Send Enquiry'}</span>
                  {status !== 'sending' && (
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M1 7h12M7 1l6 6-6 6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
